// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1NWTZ","footer":"ReportModalFilter_footer__39wbp"};